var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.287 0C3.435 0 2.348.979 2.348 3.206v1.96H0v2.349h2.348v5.64h2.348V7.516h1.879l.47-2.348H4.696V3.605c0-.84.275-1.257 1.062-1.257h1.287V.098C6.826.067 6.176 0 5.287 0Z",
    fill: "#141413"
  })));
};

export default SvgIconFacebook;